import React from "react";
import PhaseReadingChart from "./PhaseReadingChart";
import { images } from "../../common/images";

const POWER_DECIMALS = { axis: 0, tooltip: 0 };

export default function PowerConsumptionLineChart({ selectedDeviceSelectedDayData }) {
  return (
    <PhaseReadingChart
      selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      reading="p"
      name="Power Consumption"
      image={images.chartPower}
      iconBackgroundColor="rgba(32, 80, 255, 0.10)"
      unit="W"
      axisTitle="Watts (W)"
      fromZero
      decimals={POWER_DECIMALS}
    />
  );
}
